import { format } from 'date-fns';
import { SupportRequest } from '@/Components/SupportRequests/SupportRequest';
import { dateformat } from '@/utils/GlobalConstants';
import { AcknowledgedIcon, SeenIcon } from '@/Components/ui/Icons/TooltipIcon';
import { getRatingColor, getStatusColor } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface SupportPopupProps {
  supportRequest: SupportRequest;
}

const SupportPopup = ({ supportRequest }: SupportPopupProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className='flex flex-col w-full text-2xl'>
        <div className='flex flex-row mb-4'><div className="w-48 font-semibold">Work Package:</div><div>{supportRequest.workPackage}</div></div>
        <div className='flex flex-row mb-4'><div className="w-48 font-semibold">Request Type:</div><div>{supportRequest.requestType}</div></div>
        <div className='flex flex-col gap-4 mb-4'>
          <div className='flex flex-row'><div className="w-48 font-semibold">Raised By: </div> {supportRequest.raisedBy ? supportRequest.raisedBy : "N/A"} - {format(new Date(supportRequest.date), dateformat)}</div>
          <div className='flex flex-row'><div className="w-48 font-semibold">Owner: </div><div>{supportRequest.owner}</div><div className='flex flex-row my-auto px-2 space-x-2'>{supportRequest.seen ? <SeenIcon className="w-8 h-8" /> : <div className="w-8 h-8" />}{supportRequest.acknowledged ? <AcknowledgedIcon className="w-8 h-8" /> : <div className="w-8 h-8" />}</div></div>
          <div className="flex flex-row"><div className="w-48 font-semibold">Rating:</div><div className={'w-48 text-center ' + getRatingColor(supportRequest.rating as "High" | "Medium" | "Low")}>{supportRequest.rating}</div></div>
          <div className='flex flex-row'><div className="w-48 font-semibold">Due Date: </div> {format(new Date(supportRequest.dueDate), dateformat)}</div>
          <div className='flex flex-row'><div className="w-48 font-semibold">Status: </div><div className={'w-48 text-center ' + getStatusColor(supportRequest.status)}>{supportRequest.status}</div></div>
        </div>
        <div className='mb-4'>
          <div className='font-semibold'>Support Request:</div>
          <div>{supportRequest.description}</div>
        </div>
        <div className='mb-4'>
          <div className='font-semibold'>Notes:</div>
          <div>{supportRequest.notes && supportRequest.notes}</div>
        </div>
      </div>
    );
  }

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-row mr-8 justify-between'>
          <div className='flex flex-row'><div className="w-32">Work Package:</div><div>{supportRequest.workPackage}</div></div>
          <div className='flex flex-row'><div className="w-32">Request Type:</div><div className='w-24'>{supportRequest.requestType}</div></div>
      </div>
      <div className='flex flex-row mb-4 justify-between'>
        <div className='flex flex-col gap-4 mr-8'>
          <div className='flex flex-row'><div className="w-32">Raised By: </div> {supportRequest.raisedBy} - {format(new Date(supportRequest.date), dateformat)}</div>
          <div className='flex flex-row'><div className="w-32">Owner: </div><div>{supportRequest.owner}</div><div className='flex flex-row my-auto px-2 space-x-2'>{supportRequest.seen ? <SeenIcon className="w-4 h-4" /> : <div className="w-4 h-4" />}{supportRequest.acknowledged ? <AcknowledgedIcon className="w-4 h-4" /> : <div className="w-4 h-4" />}</div></div>
          <div className='flex flex-row'><div className="w-32">Due Date: </div> {format(new Date(supportRequest.dueDate), dateformat)}</div>
        </div>
        <div className='flex flex-col gap-4 mr-8'>
          <div className="flex flex-row"><div className="w-32">Rating:</div><div className={'w-24 text-center ' + getRatingColor(supportRequest.rating as "High" | "Medium" | "Low")}>{supportRequest.rating}</div></div>
          <div className='flex flex-row'><div className="w-32">Due Date: </div> {format(new Date(supportRequest.dueDate), dateformat)}</div>
          <div className='flex flex-row'><div className="w-32">Status: </div><div className={'w-24 text-center ' + getStatusColor(supportRequest.status)}>{supportRequest.status}</div></div>
        </div>
      </div>
      <div>
        <div>Support Request:</div>
        <div>{supportRequest.description}</div>
      </div>
      <div>
        <div>Notes:</div>
        <div>{supportRequest.notes && supportRequest.notes}</div>
      </div>
    </div>
  )
}

export default SupportPopup